<section *ngIf="currentLine">
    <xm-display-card class="name-section" [ngClass]="{ 'has-banner': shouldShowBanner || isLineBannerLoading }">
        <div class="display-name-section">
            <h2 [innerHtml]="displayName" data-notranslate></h2>
            <cms-text class="user-cta-desktop" *ngIf="showUserCta" [originalText]="processedUserCtaText"></cms-text>
        </div>
        <div class="info-container">
            <span class="line-status">{{ lineStatus }}</span>
            <span class="account-no" *ngIf="accountNo">{{ accountNo }}</span>
            <cms-text class="user-cta-mobile" *ngIf="showUserCta" [originalText]="processedUserCtaText"></cms-text>
        </div>
    </xm-display-card>
    <div class="banner" [ngClass]="{ 'banner-loaded': currentBanner }" *ngIf="shouldShowBanner && !isLineBannerLoading">
        <div class="hero-banner-content">
            <xm-media-image *ngIf="imageOptions.mobile.base" aria-hidden="true" class="image"
                [imageOptions]="imageOptions" center="auto" size="height"></xm-media-image>
            <div class="banner-text">
                <p class="banner-subheader">{{ bannerSubHeader }}</p>
                <p *ngIf="bannerDescription" class="banner-description">{{ bannerDescription }}</p>
            </div>
            <div class="btn-wrapper">
                <a *ngIf="buttonAttributes && buttonAttributes.hasInternalLink && bannerButtonText"
                    [uiSref]="buttonAttributes.uiSref" [uiParams]="buttonAttributes.uiParams"
                    [class]="buttonAttributes.isSecondaryButton ? 'xm-btn-secondary-light' : 'xm-btn-primary-light'">{{ bannerButtonText }}</a>
                <a *ngIf="buttonAttributes && buttonAttributes.hasExternalLink && bannerButtonText"
                    [href]="buttonAttributes.href" rel="noopener" target="_blank" [class]="buttonAttributes.isSecondaryButton ? 'xm-btn-secondary-light cta' : 'xm-btn-primary-light cta'">{{
                    bannerButtonText }}</a>
                <button *ngIf="buttonAttributes && buttonAttributes.hasButton && bannerButtonText"
                    (click)="goToBannerCtaAction()" [class]="buttonAttributes.isSecondaryButton ? 'xm-btn-secondary-light cta' : 'xm-btn-primary-light cta'">{{ bannerButtonText }}</button>
            </div>
        </div>
    </div>
    <div class="banner" *ngIf="isLineBannerLoading">
        <xm-loader-overlay type="banner" [lineBanner]="true" [avatar]="true"></xm-loader-overlay>
    </div>
    <div *ngIf="!currentLine.isPending" class="data-usage" [ngClass]="{ 'has-banner': shouldShowBanner || isLineBannerLoading }">
        <div class="data-header">
            <h3 class="header">{{ pageData.dataUsage.header }}</h3>
            <span class="usage-description">{{ pageData.dataUsage.description }}</span>
        </div>
        <div class="data-graph">
            <div class="plan-info">
                <div class="data-usage-info">
                    <p class="duration">{{ currentCycleDuration }}</p>
                    <P class="plan-name">{{ planName }}</P>
                    <p class="usage">{{ displayUsage }} GB<span class="usage usage-price" *ngIf="domesticUsageCost">{{
                            domesticUsageCost | xmCurrency:'off':false:true }}</span></p>
                </div>
                <div class="call-text-info" *ngIf="currentUsage && currentLine.isDevice">
                    <div class="text-info">
                        <p class="usage-header">{{ pageData.dataUsage.messageLabel }}</p>
                        <p class="number-count">
                            <a uiSref="account.activity.usage"
                                *ngIf="displayUsageLink(currentUsage.domesticMessageCounts)"
                                [uiParams]="{ activity: messages, statement_line_id: currentUsage.statementLineId.key, startDate: currentUsage.cycleStartDate, endDate: currentUsage.cycleEndDate, name: displayName, lineNumber: currentLine.lineNumber }">
                                {{ currentUsage.domesticMessageCounts }}
                            </a>
                            <span class="not-clickable" *ngIf="!displayUsageLink(currentUsage.domesticMessageCounts)">{{
                                currentUsage.domesticMessageCounts }}</span>
                        </p>
                    </div>
                    <div class="call-info">
                        <p class="usage-header">{{ pageData.dataUsage.callLabel }}</p>
                        <p class="number-count">
                            <a uiSref="account.activity.usage"
                                *ngIf="displayUsageLink(currentUsage.domesticVoiceCounts)"
                                [uiParams]="{ activity: call, statement_line_id: currentUsage.statementLineId.key, startDate: currentUsage.cycleStartDate, endDate: currentUsage.cycleEndDate, name: displayName, lineNumber: currentLine.lineNumber }">
                                {{ currentUsage.domesticVoiceCounts }}
                            </a>
                            <span class="not-clickable" *ngIf="!displayUsageLink(currentUsage.domesticVoiceCounts)">{{
                                currentUsage.domesticVoiceCounts }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <xm-graph [theme]="'activity'" [data]="graphData" aria-hidden="true"></xm-graph>
        </div>
        <div class="usage-history" *ngIf="usages.length">
            <usage-history [usages]="usages" [currentLine]="currentLine" [showCallAndText]="currentLine.isDevice"
                [pageData]="pageData.usageHistoryPageData"></usage-history>
        </div>
    </div>
    <div class="promo-banner" *ngIf="promoList?.length && isIcopPlanSwitch">
        <promo-banner [promoList]="promoList" [banner]="promotionsBanner"></promo-banner>
    </div>
    <xm-display-card *ngIf="currentLine.isPending" id="data-options" class="pending-data-options"
        [ngClass]="{ 'has-banner': shouldShowBanner, 'promo-banner': promoList?.length }">
        <h3 class="data-description">{{ pageData.dataOptions }}</h3>
        <p class="pending-warning-description">{{ dataOptionsWarningMessage }}</p>
    </xm-display-card>

    <xm-display-card *ngIf="!currentLine.isPending && (currentLine.hideDataOptions || currentLine.isStandaloneWatch)"
        id="data-options" [ngClass]="{ 'promo-banner': promoList?.length }">
        <xm-user-role-component *ngIf="isMember || isViewer"></xm-user-role-component>
        <div *ngIf="(!isSegmentFive && !isSeg6ResiUser && !enableCbmNoLevel) && !currentLine.isStandaloneWatch">
            <h3 class="data-description">{{ pageData.dataOptions }}</h3>
            <p class="warning-description" *ngIf="dataOptionsWarningMessage">{{ dataOptionsWarningMessage }}</p>
            <div *ngFor="let dataOptionPlan of dataOptionPlans">
                <xm-plan-detail [currentLine]="currentLine" [activePlan]="dataOptionPlan.activePlan"
                    [plan]="dataOptionPlan.plan" [planData]="dataOptionPlan.planData"
                    [isActiveLine]="dataOptionPlan.isActiveLine&&!isLineTransferPending" [isLLEEnabledMemberOrViewer]="isLLEEnabledMemberOrViewer"></xm-plan-detail>
            </div>
            <p *ngIf="disclaimerMessage" class="disclaimer">{{disclaimerMessage}}</p>
        </div>
        <!--SSM - Data Options Start -->
        <div *ngIf="(isSegmentFive || isSeg6ResiUser || enableCbmNoLevel) && !currentLine.isStandaloneWatch">
            <h3 class="data-description">{{ pageData.dataOptions }}</h3>
            <xm-plan-data-options [currentLine]="currentLine" [userRole]="userRole"></xm-plan-data-options>
        </div>
        <!--SSM - Data Options End -->
        <!-- Standalone watch data option -->
        <div *ngIf="currentLine.isStandaloneWatch">
            <div *ngFor="let dataOptionPlan of dataOptionPlans">
                <xm-plan-detail [currentLine]="currentLine" [activePlan]="dataOptionPlan.activePlan"
                    [plan]="dataOptionPlan.plan" [planData]="dataOptionPlan.planData"
                    [isActiveLine]="dataOptionPlan.isActiveLine&&!isLineTransferPending" [isLLEEnabledMemberOrViewer]="isLLEEnabledMemberOrViewer"></xm-plan-detail>
            </div>
        </div>
        <!-- Standalone watch data option end-->
        <div class="resi-broadband" *ngIf="enableFccBroadbandLabel && !isBusinessUser">
            <broadband-label *ngIf="!currentLine.isTablet"></broadband-label>
            <broadband-tablet-label *ngIf="currentLine.isTablet"></broadband-tablet-label>
        </div>
        <div class="cbm-broadband" *ngIf="isBusinessUser">
            <cbm-broadband-label [currentLine]="currentLine" [currentPlan]="currentPlan"
                [isGrandFatheredLabel]="isGrandFatheredLabel" *ngIf="currentLine.isDevice"></cbm-broadband-label>
            <cbm-broadband-tablet-label [currentLine]="currentLine"
                *ngIf="currentLine.isTablet"></cbm-broadband-tablet-label>
            <cbm-broadband-watch-label [currentLine]="currentLine"
                *ngIf="currentLine.isStandaloneWatch"></cbm-broadband-watch-label>
        </div>
    </xm-display-card>
    <xm-display-card class="addon-options" id="addon-options"
        *ngIf="(!(user.account.isSegmentFive && currentLine.isTablet) && !currentLine.isPending && (isToggleEligibility || addonsWarningMessage || showXmCallGuard() || isDatasaverEligible) && !isLoading)">
        <h3 class="data-description">{{ this.pageData.addons.planSixTitle }}</h3>
        <xm-video-resolution *ngIf="isToggleEligibility" [currentLine]="currentLine" [isSegmentFive]="isSegmentFive" [isSegmentSix]="isSegmentSix"
            [videoInfo]="videoResolutionInfo" [pageData]="cmsVideoResolution" [userRole]="userRole"
            [isLastChild]="isToggleEligibility && !addonsWarningMessage && !isDatasaverEligible"></xm-video-resolution>
        <p class="warning-description" *ngIf="addonsWarningMessage">{{ addonsWarningMessage }}</p>
        <div class="addons" *ngIf="showXmCallGuard()">
            <xm-call-guard [userRole]="userRole"></xm-call-guard>
        </div>
        <xm-data-saver *ngIf="isDatasaverEligible" [isStatusOn]="isStatusOn"
            [isActiveLine]="currentLine.isActive&&!isLineTransferPending"></xm-data-saver>
    </xm-display-card>
    <xm-display-card class="addon-options" id="addon-options"
        *ngIf="(!(user.account.isSegmentFive && currentLine.isTablet) && !isViewer && !currentLine.isPending && showAddonsSection && !isLoading)">
        <h3 class="data-description">{{ this.pageData.addons.gtp1bTitle }}</h3>
        <div class="addons" *ngFor="let addon of newAddons">
            <xm-new-addons-detail [addon]="addon"></xm-new-addons-detail>
        </div>
    </xm-display-card>
    <xm-display-card class="addon-options" id="addon-options"
        *ngIf="(user.account.isSegmentFive && currentLine.isTablet) && !currentLine.isPending && currentLine.isVideoResolution && videoResolutionInfo && !isLoading">
        <h3 class="data-description">{{ this.pageData.addons.planSixTitle }}</h3>
        <xm-video-resolution *ngIf="isToggleEligibility" [currentLine]="currentLine" [isSegmentFive]="isSegmentFive" [isSegmentSix]="isSegmentSix"
            [videoInfo]="videoResolutionInfo" [pageData]="cmsVideoResolution"></xm-video-resolution>
    </xm-display-card>
    <xm-display-card *ngIf="isLoading" class="addon-options" id="addon-options">
        <xm-loader-overlay type="billing-card" page="line-details" [avatar]="true"
            [isAddonsCards]="true"></xm-loader-overlay>
        <xm-loader-overlay type="billing-card" [avatar]="true" [isAddonsCards]="true"></xm-loader-overlay>
    </xm-display-card>
    <xm-display-card
        *ngIf="(!(user.account.isSegmentFive && currentLine.isTablet) && !currentLine.isPending && showAddonsSection && isLoading)"
        class="addon-options" id="addon-options">
        <xm-loader-overlay type="billing-card" page="line-details" [avatar]="true"
            [isAddonsCards]="true"></xm-loader-overlay>
        <xm-loader-overlay type="billing-card" [avatar]="true" [isAddonsCards]="true"></xm-loader-overlay>
    </xm-display-card>
    <xm-display-card *ngIf="(currentLine.pairedLines.length)" class="paired-device">
        <h3 class="data-description">{{ pageData.pairedDevice.header }}</h3>
        <div class="pair-device" *ngFor="let pairedLine of pairedLines">
            <xm-media-image aria-hidden="true" [imageOptions]="watchStaticImage" size="auto"
                class="watch-image"></xm-media-image>
            <div class="watch-description">
                <h4 class="header">{{ pairedLine.name }}</h4>
                <p class="info">{{ pageData.pairedDevice.watchaDataLabel }}, {{ pairedLine.planPrice }}</p>
                <p class="info">{{ pageData.pairedDevice.unlimitedTalkLabel }}</p>
            </div>
        </div>
    </xm-display-card>
</section>
<xm-display-card *ngIf="!currentLine">
    <xm-my-account-error [apiRequestData]="apiRequestData"></xm-my-account-error>
</xm-display-card>
